/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import add_exercise from "../img/add_exercise.jpg";
import { useNavigate } from "react-router-dom";
import "../components/style.css";
import Axios from "axios";
import Swal from 'sweetalert2';
import running from "../img/running.png"
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import jwt from "jsonwebtoken";
import { getlocalStorage, formatdate, thai_date, thai_date_picker } from '../function/functionALL';
import th from 'date-fns/locale/th';
import { BsArrowRightCircle, BsArrowLeftCircle, BsCalendarDateFill } from "react-icons/bs";
function ModalAddExercise({
    onClose,
    onSave,
    show,
    setChkEmpty,
    budget_year,
    setbudget_year,
    round,
    setround,
    date,
    setdate, dateshow_picker, setdateshow_picker }) {

    const handleClose = () => {
        setbudget_year("");
        setround("");
        setdate("");
        setdateshow_picker("")
        onClose();
    };

    const navigate = useNavigate();
    const { Token, DataToken_ } = getlocalStorage();
    const [TestRound, setTestRound] = useState([]);
    // const [dateshow_picker, setdateshow_picker] = useState("")
    const [pickerOpen, setPickerOpen] = useState(false); // สถานะเปิดปิดของ DatePicker

    const handleDateChange = (value) => {
        setdate(value); // เก็บวันที่ในรูปแบบ ค.ศ.
        setdateshow_picker(thai_date_picker(value)); // แสดงวันที่ในรูปแบบ พ.ศ.
        setPickerOpen(false); // ปิดปฏิทินหลังเลือกวันที่
    };

    useEffect(() => {
        Axios.get(process.env.REACT_APP_API_TESTROUND, {
            headers: {
                Authorization: "Token " + Token,
            },
        })
            .then((res) => {
                setTestRound(res.data.results);

            })
            .catch((err) => {
                if (err.response.status === 401) {
                    localStorage.removeItem("Token_");
                    localStorage.removeItem("Token");
                    navigate('/notfound404',
                    )
                }
                console.error(err);
                Swal.fire({
                    icon: "error",
        
                  })
            });
    }, []);


    const AddTest_round = () => {

        let date_ = formatdate(date);

        if (
            budget_year === "" ||
            round === "" ||
            date === null
        ) {

            Swal.fire({
                icon: 'error',
                title: 'เพิ่มข้อมูลไม่สำเร็จ!',
                text: 'กรอกข้อมูลให้ครบถ้วน และถูกต้อง'
            })
            setChkEmpty(false);

        }

        else if (budget_year.length !== 4) {

            Swal.fire({
                icon: 'error',
                title: 'เพิ่มข้อมูลไม่สำเร็จ!',
                text: 'กรุณากรอกข้อมูลให้ถูกต้อง'
            })
            setChkEmpty(false);

        } else {
            if (DataToken_.unit_id !== DataToken_.work_unit_id) {

                if (
                    TestRound.some((row) => (row.budget_year == (budget_year - 543)) && (row.round == round))
                ) {

                    Swal.fire({
                        icon: 'warning',
                        title: 'เพิ่มข้อมูลไม่สำเร็จ!',
                        text: 'วงรอบการทดสอบนี้มีอยู่แล้ว'
                    })
                    setChkEmpty(false);

                } else if (

                    TestRound.some((row) => row.date === date_)
                ) {

                    Swal.fire({
                        icon: 'warning',
                        title: 'เพิ่มข้อมูลไม่สำเร็จ!',
                        text: 'วันที่ทดสอบนี้มีอยู่แล้ว'
                    })
                    setChkEmpty(false);

                } else {
                    const resultAddRound = {
                        budget_year: budget_year - 543,
                        round: round,
                        date: date_,
                        // unit: DataLogin.unit_id,
                        unit: DataToken_.work_unit_id,
                        recorder: DataToken_.id,
                        status: 1,
                    }
                    onSave(resultAddRound)
                    // Axios.post(process.env.REACT_APP_API_TESTROUND, {
                    //     budget_year: budget_year - 543,
                    //     round: round,
                    //     date: date_,
                    //     // unit: DataLogin.unit_id,
                    //     unit: DataToken_.work_unit_id,
                    //     recorder: DataToken_.id,
                    //     status: 1,
                    // }, {
                    //     headers: {
                    //         Authorization: "Token " + Token
                    //     }
                    // })
                    //     .then((res) => {
                    //         Swal.fire({
                    //             icon: 'success',
                    //             title: 'เพิ่มวงรอบสำเร็จ',

                    //         })
                    //         handleClose();
                    //         setIsUpdated(true);
                    //         console.log("2")
                    //     },

                    //     )
                    //     .catch((err) => {
                    //         if (err.response.status === 401) {
                    //             localStorage.removeItem("Token_");
                    //             localStorage.removeItem("Token");
                    //             navigate('/notfound404',
                    //                 // { state: {statusCode: err.response.status, txt: err.response.data} }
                    //             )
                    //         }
                    //         console.error(err);
                    //     });

                }
            } else {
                const resultAddRound = {
                    budget_year: budget_year - 543,
                    round: round,
                    date: date_,
                    // unit: DataLogin.unit_id,
                    unit: DataToken_.work_unit_id,
                    recorder: DataToken_.id,
                    status: 1,
                }

                onSave(resultAddRound)
                // Axios.post(process.env.REACT_APP_API_TESTROUND, {
                //     budget_year: budget_year - 543,
                //     round: round,
                //     date: date_,
                //     // unit: DataLogin.unit_id,
                //     unit: DataToken_.work_unit_id,
                //     recorder: DataToken_.id,
                //     status: 1,
                // }, {
                //     headers: {
                //         Authorization: "Token " + Token
                //     }
                // })
                //     .then((res) => {

                //     },
                //         Swal.fire({
                //             icon: 'success',
                //             title: 'เพิ่มวงรอบสำเร็จ',
                //             html: 'กรุณารอสักครู่ ( <b></b> วินาที )',
                //             timer: 1500,
                //             timerProgressBar: true,
                //             didOpen: () => {
                //                 Swal.showLoading()
                //                 const b = Swal.getHtmlContainer().querySelector('b')
                //                 timerInterval = setInterval(() => {
                //                     b.textContent = Swal.getTimerLeft()
                //                 }, 100)
                //             },
                //             willClose: () => {
                //                 clearInterval(timerInterval)
                //             }
                //         }).then((result) => {

                //             // navigate(0);
                //             /* Read more about handling dismissals below */
                //             if (result.dismiss === Swal.DismissReason.timer) {
                //                 console.log('I was closed by the timer')
                //             }
                //         })
                //     )
                //     .catch((err) => {
                //         if (err.response.status === 401) {
                //             localStorage.removeItem("Token_");                            
                //             localStorage.removeItem("Token");
                //             navigate('/notfound404',
                //                 // { state: {statusCode: err.response.status, txt: err.response.data} }
                //             )
                //         }
                //         console.error(err);
                //     });
            }
        }
    }
    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={false}
            >
                <Modal.Body>
                    <div className="rounded">
                        <div className="p-2">
                            <div className="col-sm-12 col-xs-12">
                                <div className="card-body rounded">
                                    <div className="row d-flex p-2">
                                        <div className="col-3 col-xs-12 col-sm-12 card-title text-center fs-5 w-100 fs-3" style={{ color: "#000000" }}>
                                            <div className="fw-bold" style={{ fontSize: "25px" }}>เพิ่มรอบการทดสอบ</div>
                                            <div className="fw-bold" style={{ fontSize: "25px" }}>สมรรถภาพทางกาย</div>
                                        </div>
                                        <hr></hr>
                                    </div>
                                    <div className="row g-3">
                                        <div className="row col-lg-12 ms-1">
                                            <div className="col-12 col-lg-6 mt-2 mb-3 d-flex">
                                                <div className="col-5 col-lg-6">
                                                    <label className="col-12 col-lg-12 col-form-label fs-6">ปีงบประมาณ :</label>
                                                </div>
                                                <div className="col-7 col-lg-6 d-flex align-items-center">
                                                    <input type="number" className="form-control" id="inputText" placeholder="กรอกปี พ.ศ."
                                                        value={budget_year} onChange={(event) => {
                                                            setbudget_year(event.target.value);
                                                        }}
                                                    ></input>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 mt-2 mb-3 d-flex justify-content-center align-items-center">
                                                <div className="col-lg-2"></div>
                                                <label className="col-5 col-lg-4 col-form-label">รอบที่ :</label>
                                                <div className="col-7 col-lg-6">
                                                    <input type="number" className="form-control" id="inputText" placeholder="กรอก"
                                                        value={round} onChange={(event) => {
                                                            setround(event.target.value);
                                                        }}
                                                    ></input>
                                                </div>
                                            </div>
                                            <div className=" col-12 col-lg-6 mt-2 mb-2 justify-content-center align-items-center">
                                                <div className=" col-12 col-lg-12 d-flex">
                                                    <label className=" col-5 col-lg-6 col-form-label">วันที่ :</label>

                                                    <div className="col-7 col-lg-6   " >
                                                        <div className="input-group">
                                                            <span
                                                                className="input-group-text col-4 p-1 m-0 position-relative  justify-content-center"
                                                            style={{backgroundColor:'#8A80CE'}}>

                                                                <BsCalendarDateFill style={{color:"white"}} onClick={() => setPickerOpen(true)} />
                                                                {pickerOpen && (
                                                                    <div style={{ position: 'absolute', top: '100%', left: '-80px', zIndex: 1000 }}>
                                                                        <DatePicker
                                                                            selected={date}
                                                                            onChange={handleDateChange}
                                                                            locale={th}
                                                                            dateFormat="dd-MM-yyyy"
                                                                            // onKeyDown={(e) => e.preventDefault()}
                                                                            inline
                                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                                <div className="d-flex justify-content-between align-items-center" style={{ background: '#8A80CE', border: 'none' }}>
                                                                                    <button type="button" className="btn btn-light me-2 m-2" onClick={decreaseMonth}>
                                                                                        <BsArrowLeftCircle style={{ fontSize: '20px' }} />
                                                                                    </button>
                                                                                    <span className="mx-2" style={{ fontSize: '16px' }}>
                                                                                        {thai_date(date, 'month')}
                                                                                    </span>
                                                                                    <button type="button" className="btn btn-light me-2 m-2" onClick={increaseMonth}>
                                                                                        <BsArrowRightCircle style={{ fontSize: '20px' }} />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </span>

                                                            <input

                                                                className="form-control col-7  "
                                                                value={dateshow_picker} readOnly
                                                                style={{
                                                                    fontSize: "12px"
                                                                }}
                                                                placeholder="กรุณาเลือกวันที่"

                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=" col-12 col-lg-12 d-flex">
                                                    <label className=" col-4 col-lg-6 col-form-label"></label>
                                                    <label className=" col-9 col-lg-6 col-form-label text-center" style={{ fontSize: "14px", }}>( ตัวอย่าง : วัน-เดือน-ปี )</label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 mt-2 mb-3 justify-content-center align-items-center">
                                                <div className=" col-12 col-lg-12 d-flex">
                                                    <div className="col-lg-2"></div>
                                                    <label className="col-5 col-lg-4 col-form-label ">หน่วย :</label>
                                                    <input type="text" className="form-control" id="inputText" placeholder="กรอก"
                                                        value={DataToken_.work_unit}
                                                        style={{ fontSize: "16px" }} disabled></input>
                                                </div>
                                                <div className=" col-12 col-lg-12 d-flex">
                                                    <label className=" col-4 col-lg-6 col-form-label"></label>
                                                    <label className=" col-9 col-lg-6 col-form-label text-center" style={{ fontSize: "14px", }}></label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 mt-2 mb-3 d-flex justify-content-center">
                                                <div className="col-5 col-lg-6">
                                                    <label className="col-12 col-lg-12 col-form-label fs-6">ผู้บันทึก :</label>
                                                </div>
                                                <div className="col-7 col-lg-6 d-flex align-items-center">
                                                    <input type="text" className="form-control " id="inputText" placeholder="กรอก"
                                                        value={DataToken_.full_name}
                                                        style={{ fontSize: "16px" }} disabled></input>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">
                        <Button variant="primary" style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }} onClick={() => {
                            AddTest_round();

                        }}>
                            ยืนยัน
                        </Button>
                        <Button variant="secondary" onClick={handleClose}>
                            ยกเลิก / ย้อนกลับ
                        </Button>
                    </div>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalAddExercise
